var _metadata, _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    contentScriptType: "text/ecmascript",
    contentStyleType: "text/css",
    viewBox: "0 0 24 23.999999",
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.422-10.891h-10.547v10.891h-5.5v-26.656h17.359v4.4531h-11.859v6.875h10.547z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.625 0h-5.3125v-19.812h5.3125zm-5.625-24.938c0-0.78906 0.26562-1.4414 0.79688-1.9531 0.53125-0.51953 1.2539-0.78125 2.1719-0.78125 0.89453 0 1.6094 0.26172 2.1406 0.78125 0.53906 0.51172 0.8125 1.1641 0.8125 1.9531 0 0.80469-0.27344 1.4648-0.8125 1.9844-0.54297 0.51172-1.2617 0.76562-2.1562 0.76562-0.88672 0-1.6016-0.25391-2.1406-0.76562-0.54297-0.51953-0.8125-1.1797-0.8125-1.9844z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.172-14.844c-0.73047-0.10156-1.3672-0.15625-1.9062-0.15625-2 0-3.3125 0.67969-3.9375 2.0312v12.969h-5.2969v-19.812h5l0.14062 2.3594c1.0625-1.8125 2.5352-2.7188 4.4219-2.7188 0.58203 0 1.1289 0.07813 1.6406 0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.766-5.4688c0-0.65625-0.32422-1.1641-0.96875-1.5312-0.63672-0.375-1.6641-0.70703-3.0781-1-4.7188-0.98828-7.0781-2.9883-7.0781-6 0-1.7578 0.72656-3.2266 2.1875-4.4062 1.4688-1.1758 3.3789-1.7656 5.7344-1.7656 2.5078 0 4.5195 0.59375 6.0312 1.7812 1.5078 1.1797 2.2656 2.7148 2.2656 4.6094h-5.2969c0-0.75781-0.24609-1.3828-0.73438-1.875-0.49219-0.5-1.25-0.75-2.2812-0.75-0.89844 0-1.5898 0.20312-2.0781 0.60938-0.49219 0.39844-0.73438 0.90625-0.73438 1.5312 0 0.58594 0.27344 1.0586 0.82812 1.4219 0.5625 0.35547 1.5 0.66797 2.8125 0.9375 1.3203 0.26172 2.4375 0.55859 3.3438 0.89062 2.7891 1.0234 4.1875 2.7969 4.1875 5.3281 0 1.8047-0.77734 3.2617-2.3281 4.375-1.5547 1.1172-3.5547 1.6719-6 1.6719-1.6562 0-3.1328-0.29297-4.4219-0.875-1.293-0.59375-2.3047-1.4062-3.0312-2.4375-0.73047-1.0312-1.0938-2.1445-1.0938-3.3438h5.0156c0.039063 0.9375 0.38281 1.6562 1.0312 2.1562 0.65625 0.5 1.5234 0.75 2.6094 0.75 1.0078 0 1.7734-0.19141 2.2969-0.57812 0.51953-0.38281 0.78125-0.88281 0.78125-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.375-24.688v4.875h3.375v3.875h-3.375v9.8906c0 0.74219 0.13281 1.2734 0.40625 1.5938 0.28125 0.3125 0.82031 0.46875 1.625 0.46875 0.58203 0 1.0977-0.046875 1.5469-0.14062v4.0156c-1.0312 0.3125-2.1016 0.46875-3.2031 0.46875-3.7109 0-5.6016-1.8672-5.6719-5.6094v-10.688h-2.8906v-3.875h2.8906v-4.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.438-5.5h-9.6406l-1.8281 5.5h-5.8438l9.9219-26.656h5.0938l9.9844 26.656h-5.8438zm-8.1562-4.4375h6.6719l-3.3594-9.9844z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.266-3.9062c0.97656 0 1.7695-0.26562 2.375-0.79688 0.61328-0.53906 0.9375-1.2539 0.96875-2.1406h4.9531c-0.01172 1.3438-0.375 2.5742-1.0938 3.6875-0.71875 1.1172-1.7031 1.9805-2.9531 2.5938-1.25 0.61328-2.6367 0.92188-4.1562 0.92188-2.8359 0-5.0703-0.89453-6.7031-2.6875-1.6367-1.8008-2.4531-4.2891-2.4531-7.4688v-0.34375c0-3.0508 0.8125-5.4844 2.4375-7.2969 1.625-1.8203 3.8516-2.7344 6.6875-2.7344 2.4766 0 4.4609 0.70312 5.9531 2.1094 1.5 1.4062 2.2578 3.2812 2.2812 5.625h-4.9531c-0.03125-1.0195-0.35547-1.8477-0.96875-2.4844-0.60547-0.64453-1.4062-0.96875-2.4062-0.96875-1.2305 0-2.1641 0.44922-2.7969 1.3438-0.625 0.89844-0.9375 2.3516-0.9375 4.3594v0.5625c0 2.0312 0.3125 3.4961 0.9375 4.3906 0.625 0.88672 1.5664 1.3281 2.8281 1.3281z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.625 0h-5.3125v-28.125h5.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.156 0.35938c-2.9062 0-5.2773-0.89062-7.1094-2.6719-1.8242-1.7812-2.7344-4.1562-2.7344-7.125v-0.5c0-1.9883 0.38281-3.7695 1.1562-5.3438 0.76953-1.5703 1.8594-2.7812 3.2656-3.625 1.4141-0.84375 3.0234-1.2656 4.8281-1.2656 2.707 0 4.8359 0.85547 6.3906 2.5625 1.5625 1.7109 2.3438 4.1328 2.3438 7.2656v2.1562h-12.609c0.16406 1.293 0.67578 2.3281 1.5312 3.1094 0.86328 0.78125 1.957 1.1719 3.2812 1.1719 2.0391 0 3.6328-0.73438 4.7812-2.2031l2.5938 2.9062c-0.79297 1.125-1.8672 2-3.2188 2.625-1.3555 0.625-2.8555 0.9375-4.5 0.9375zm-0.60938-16.25c-1.0547 0-1.9062 0.35547-2.5625 1.0625-0.64844 0.71094-1.0625 1.7188-1.25 3.0312h7.3594v-0.42188c-0.02344-1.1641-0.33984-2.0664-0.95312-2.7031-0.60547-0.64453-1.4688-0.96875-2.5938-0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.2188 0h-5.4844v-26.656h5.4844z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.9062-19.812 0.15625 2.2969c1.4141-1.7695 3.3164-2.6562 5.7031-2.6562 2.0938 0 3.6484 0.61719 4.6719 1.8438 1.0312 1.2305 1.5625 3.0742 1.5938 5.5312v12.797h-5.2969v-12.672c0-1.125-0.24609-1.9375-0.73438-2.4375-0.49219-0.50781-1.3047-0.76562-2.4375-0.76562-1.4922 0-2.6055 0.63672-3.3438 1.9062v13.969h-5.2969v-19.812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.859-9.7188c0 3.0547-0.69531 5.4961-2.0781 7.3281-1.3867 1.8359-3.2578 2.75-5.6094 2.75-2 0-3.6172-0.69141-4.8438-2.0781v9.3438h-5.2969v-27.438h4.9062l0.1875 1.9375c1.2812-1.5312 2.9531-2.2969 5.0156-2.2969 2.4375 0 4.332 0.90234 5.6875 2.7031 1.3516 1.8047 2.0312 4.293 2.0312 7.4688zm-5.2812-0.39062c0-1.8438-0.32812-3.2656-0.98438-4.2656s-1.6055-1.5-2.8438-1.5c-1.6562 0-2.7969 0.63672-3.4219 1.9062v8.1094c0.64453 1.3047 1.7969 1.9531 3.4531 1.9531 2.5312 0 3.7969-2.0664 3.7969-6.2031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2031-10.094c0-1.957 0.37891-3.707 1.1406-5.25 0.75781-1.5391 1.8477-2.7266 3.2656-3.5625 1.4258-0.84375 3.0781-1.2656 4.9531-1.2656 2.6758 0 4.8594 0.82031 6.5469 2.4531 1.6875 1.6367 2.6289 3.8555 2.8281 6.6562l0.04687 1.3594c0 3.043-0.85156 5.4805-2.5469 7.3125-1.6992 1.8359-3.9805 2.75-6.8438 2.75-2.8555 0-5.1367-0.91016-6.8438-2.7344-1.6992-1.832-2.5469-4.3203-2.5469-7.4688zm5.2969 0.39062c0 1.875 0.35156 3.3125 1.0625 4.3125 0.70703 0.99219 1.7227 1.4844 3.0469 1.4844 1.2812 0 2.2812-0.48828 3-1.4688 0.71875-0.97656 1.0781-2.5508 1.0781-4.7188 0-1.8438-0.35938-3.2695-1.0781-4.2812-0.71875-1.0078-1.7344-1.5156-3.0469-1.5156-1.293 0-2.293 0.50781-3 1.5156-0.71094 1-1.0625 2.5586-1.0625 4.6719z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m97.547 49.426h142.5v142.5h-142.5z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.053333 0 0 .053333 177.5 177.5)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 165.24942,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#fai_glyph-0-6",
    xlinkShow: "embed",
    xlinkType: "simple"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.12984 -.049116)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)",
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168.8 49.426c-39.348 0-71.25 31.898-71.25 71.25s31.902 71.25 71.25 71.25c39.352 0 71.25-31.898 71.25-71.25s-31.898-71.25-71.25-71.25zm-13.07 107.85-31.371-31.375 10.457-10.453 20.914 20.914 47.059-47.059 10.453 10.457z",
    fill: "#16a637"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m14.301 5.3867c-0.0211 0.021101-0.0451 0.039564-0.07227 0.054993-0.16237 0.092315-0.3687 0.035475-0.46102-0.12687-0.14946-0.2632-0.33492-0.50608-0.55113-0.72233-0.13216-0.13215-0.13216-0.34618 0-0.47806 0.13188-0.13215 0.34618-0.13215 0.47806 0 0.25909 0.25909 0.48163 0.55059 0.66102 0.86624 0.07688 0.13545 0.05025 0.30112-0.05459 0.40608",
    strokeWidth: 0.070334
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.6 3.8305c-0.09693 0.09693-0.24755 0.12884-0.37969 0.068444-0.78881-0.36046-1.7116-0.40195-2.5315-0.11407-0.17611 0.06185-0.36926-0.030992-0.43107-0.20715-0.061851-0.17611 0.030991-0.36926 0.20715-0.43107 0.99763-0.35031 2.076-0.30168 3.0365 0.13709 0.16979 0.077809 0.24453 0.27831 0.16704 0.44812-0.01727 0.037585-0.04061 0.070818-0.06844 0.098644",
    strokeWidth: 0.070334
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.329 6.9824c0 1.2042-0.46899 2.3362-1.3204 3.1879-0.8514 0.8514-1.9837 1.3204-3.1876 1.3204-1.2042 0-2.3365-0.46898-3.1879-1.3204-0.8514-0.85169-1.3204-1.9837-1.3204-3.1879 0-1.2042 0.46898-2.3362 1.3204-3.1876 0.8514-0.85168 1.9837-1.3206 3.1879-1.3206 1.2039 0 2.3362 0.469 3.1876 1.3206 0.8514 0.8514 1.3204 1.9834 1.3204 3.1876zm-8.4929-3.9846c-2.2004 2.2006-2.2004 5.7686 0 7.969 2.1115 2.1115 5.4812 2.1966 7.6947 0.25661l0.21348 0.21348c-0.06673 0.25057-0.0026 0.52888 0.19396 0.7253l3.2164 3.2162c0.29343 0.2937 0.76903 0.2937 1.0624 0 0.29343-0.29343 0.29343-0.76904 0-1.0624l-3.2162-3.2162c-0.19671-0.19672-0.47476-0.26101-0.72529-0.19398l-0.21348-0.21375c1.9399-2.2134 1.8549-5.5832-0.25661-7.6947-2.2008-2.2008-5.7689-2.2008-7.9696 0",
    strokeWidth: 0.070334
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 89.15625,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#y",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 109.69426,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#o",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 119.63379,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#s",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 133.3075,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#t",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 152.58247,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#p",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 174.58488,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#v",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 199.80893,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#s",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 213.48264,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#p",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 226.14957,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#o",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 236.0891,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#u",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 255.63866,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#w",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 265.57819,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#q",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 99.046875,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#z",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 109.97486,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#r",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 130.97049,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#t",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 150.24548,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#aa",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 171.35095,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#q",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 191.6144,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#u",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 211.16394,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#p",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 223.83089,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#o",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 233.77042,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#ab",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070334 0 0 .070334 -1.116 -1.2336)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 254.96739,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#r",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaiIcon);
export default __webpack_public_path__ + "static/media/fai_icon.9bcbf249.svg";
export { ForwardRef as ReactComponent };